"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive("tlBookmark", function ($location, $http, $notifications, $translate, $applications) {
  return {
    restrict: "E",
    scope: {
      titre: "@",
      icone: "@",
      url: "@",
      /**
       * type : optionnel, permet d'identifier facilement que des liens sont de même nature
       */
      type: "@",
      /**
       * optionnel, permet d'avoir un identifiant le d'entité qui a été bookmarquée
       */
      entiteId: "@"
    },
    replace: true,
    template: require("./tlBookmark.html"),
    controller: function controller($scope) {
      $scope.bookmarkUrl = $scope.url;
      $scope.$watch('url', function (newUrl) {
        // evite d'afficher le lien tant qu'on a pas chargé
        $scope.loaded = false;
        if (!$scope.url) {
          // par defaut l'url courant
          $scope.bookmarkUrl = $location.url();
        } else {
          $scope.bookmarkUrl = $scope.url;
        }
        $http.get('/rest/bookmark/url', {
          params: {
            url: $scope.bookmarkUrl
          }
        }).then(function (response) {
          $scope.loaded = true;
          // on récupère "" si rien... étrange non ?
          if (response.data && response.data.id != null) {
            $scope.bookmark = response.data;
          } else {}
        }).finally(function () {});
      });
      $scope.changeBookmark = function () {
        if ($scope.bookmark == null) {
          $http.post("/rest/bookmark/save", {
            url: $scope.bookmarkUrl,
            titre: $scope.titre || $scope.url,
            icone: $scope.icone,
            type: $scope.type,
            entiteId: $scope.entiteId,
            application: $applications.getCurrentAppId()
          }).then(function (response) {
            $scope.bookmark = response.data;
            $notifications.info($translate("raccourci.Enregistre"));
          });
        } else {
          $http.delete("/rest/bookmark/delete/" + $scope.bookmark.id);
          $scope.bookmark = null;
          $notifications.info($translate("raccourci.Retire"));
        }
      };
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/bookmark/tlBookmark.js
// module id = 2679
// module chunks = 13